<template>
  <a
    :title=" formType === 'login' ? 'Login with Facebook' : 'Sign up with Facebook'"
    v-on="formType === 'login' ? { click: logInWithFacebook } : { click: socialSignUp }"
  >
    <FacebookIcon />
    <span>
      Facebook
    </span>
  </a>
</template>
<script>
import FacebookIcon from '../../assets/svg/icon-colored-fb.svg?vue-component';

export default {
  components: { FacebookIcon },
  props: {
    keepMeLoggedIn: Boolean,
    errored: Boolean,
    campaign: Boolean,
    termsAgreed: Boolean,
    formType: { type: String, default: '' },
  },
  async mounted() {
    await this.loadFacebookSDK(document, 'script', 'facebook-jssdk');
    await this.initFacebook();
  },
  methods: {
    async logInWithFacebook() {
      await this.$root.$emit('check');
      if (!this.errored) {
        const fbToken = Object.keys(localStorage).find((k) => k.includes('fblst_'));

        if (fbToken) {
          localStorage.removeItem(fbToken);
        }

        window.FB.login(
          async (response) => {
            if (response.status === 'connected') {
              const { accessToken } = response.authResponse;
              const request = await this.$axios.$post(`/auth/social/facebook?rkey=${this.$route.query.rkey}&checkout=true`, { token: accessToken });
              if (request && request.businessAccount) {
                this.$store.dispatch('auth/setUserInfo', request);
              }
              if (request && request.user) {
                if (request.user.registered) {
                  const eventID = `${this.$store.state.tracking.sessionId}${Date.now()}`;
                  dataLayer.push({ event: 'FreeSignup', signupType: 'Facebook', eventID });
                  this.$tracking.sendEvent({
                    dataLayerEvent: 'SignUp',
                    destinationUrl: this.$router.currentRoute.fullPath,
                    eventID,
                    capi: true,
                    userAgent: navigator.userAgent,
                  });
                }

                this.$store.dispatch('auth/setUserInfo', request.user);
                this.$emit('login');
              }
            }
          },
          { scope: 'public_profile, email' },
        );
      }
      return false;
    },

    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: this.$config.facebookApiKey,
          cookie: true,
          version: 'v9.0',
        });
      };
    },

    async loadFacebookSDK(d, s, id) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      // eslint-disable-next-line prefer-const
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    },
    checkTerms() {
      this.$root.$emit('check-terms', true);
    },
    socialSignUp() {
      if (this.termsAgreed) {
        this.logInWithFacebook();
      }
      this.checkTerms();
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  border-radius: 0;
  text-align: center;
  transition: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  color: var(--main-light);
  padding: var(--spacing-14);

  svg {
    vertical-align: sub;
    margin-right: var(--spacing-16);
  }
}

@include bp($bp-mobile) {
  a {
    svg {
      margin-right: -2px;
    }

    span {
      display: none;
    }
  }
}
</style>
